import styled from "styled-components";

const TagsContainer = styled.div`
    display: flex;
    gap: 2rem;
    align-content: space-around;
    align-items: center;
`;

export default TagsContainer;